const styles = (props) => ({
	modal: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	container: {
		background: props.palette.secondary.darker,
		display: "flex",
		borderRadius: "22px",
		maxWidth: "748px",
		width: "80%",
		maxHeight: "89vh",
		overflow: "auto",
		flexDirection: "column",
		gap: 2,
		p: 2,
	},
	title: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: props.palette.white.main,
	},
	body: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
		p: 2,
		pt: 2,
		borderRadius: "22px",
		background: props.palette.background.modalContrast,
	},
	content: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		width: "100%",
	},
	form: { display: "flex", flexDirection: "row", gap: "64px" },

	asTextField: {
		width: "340px",
		"@media (max-width: 920px)": {
			width: "100%",
		},
		"& .MuiInputLabel-root.Mui-error": {
			color: "secondary.main",
		},
		"& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
			border: "3px solid",
			borderColor: "secondary.main",
		},
		"& .MuiFormHelperText-root.Mui-error": {
			color: "secondary.main",
		},
	},
	stack: {
		width: "100%",
	},
	boxForm: { display: "flex", flexDirection: "column", gap: 1, width: "100%" },
	boxButton: {
		display: "flex",
		justifyContent: "end",
		"@media (max-width: 920px)": { justifyContent: "center" },
	},
	button: {
		borderRadius: "10px",
		mr: 2,

		"@media (max-width: 340px)": { width: "100%" },
	},
});

export default styles;
